module.exports = __webpack_public_path__ + "img/absolut-reg-logo.500dc250.png";